import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-item__input-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item", {
			'form-item--has-error': _ctx.hasError,
			'form-item--half': _ctx.half,
			'form-item--quarter': _ctx.quarter,
			'form-item--has-empty-input': _ctx.isEmpty,
			'form-item--below': _ctx.errorBelow,
		}])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "form-item__label",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args)))
        }, [
          _renderSlot(_ctx.$slots, "label", _normalizeProps(_guardReactiveProps({ label: _ctx.label })), () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_error_message, {
      visible: _ctx.hasError,
      class: "form-item__error"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.error), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}